import React from 'react';
import { StepItemsList } from '../common/styles';
import EventCardSkeleton from './EventCardSkeleton';

type EventListSkeletonProps = {
    ariaLabel?: string;
    dataAuto?: string;
    className?: string;
};

const EventListSkeleton: React.FC<EventListSkeletonProps> = ({
    ariaLabel,
    dataAuto,
    className,
}) => {
    return (
        <StepItemsList
            aria-label={ariaLabel}
            data-auto={dataAuto}
            className={className}
        >
            <EventCardSkeleton />
            <EventCardSkeleton />
        </StepItemsList>
    );
};

export default EventListSkeleton;
